import { RestQueryHookOptions, useRestQuery } from 'utils/hooks/api/useRestQuery';
import { GraphQLCampaign } from 'modules/campaigns/lib/types';

const CALCULATE_SEND_SIZE_URL = '/i/campaigns/calculateSendSize';

type CalculateSendSizeResponse = {
  sendSize: number;
};

/**
 * The "expectedSendSize" field within a campaign is only populated after
 * the campaign is scheduled. Prior to that (when a campaign is in the draft/ready state),
 * we use the send size fetched via '/i/campaigns/calculateSendSize'.
 */
export const useQueryEstimatedSendSize = (
  campaignId?: GraphQLCampaign['id'],
  options?: RestQueryHookOptions<CalculateSendSizeResponse>,
) => {
  /**
   * This endpoint can incorrectly return a send size even when the campaign has no associated
   * send lists, so ensure that undefined is returned in this case
   */
  const {
    data,
    refetch,
    isError: hasError,
    isLoading,
    isFetching,
  } = useRestQuery<CalculateSendSizeResponse>(
    CALCULATE_SEND_SIZE_URL,
    { campaignId },
    { refetchOnWindowFocus: false, cacheTime: 0, staleTime: 0, ...options },
  );

  return { isLoading, isFetching, sendSize: data?.sendSize, hasError, refetch };
};
